import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CustomerOrderImportPage } from "src/components/views/erp/sales/customerOrder/CustomerOrderImportPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/sales/customerOrderImport")({
	staticData: { title: i18n.t("import_customer_orders"), legacyViewKey: "customerOrderImportPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CustomerOrderImportPage />;
}
